module.exports = __webpack_public_path__ + "media/images/review/ico-review-edit-129337176b22b89e015a478e5a9d8373.svg";